import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';

class AtenaService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiUserURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  listSenders = ({ userId, page, max_results }) => {
    const request = {
      method: 'GET',
      url: '/senders',
      params: {
        user_id: userId,
        page,
        max_results: max_results || 10,
      },
    };
    return this.axios(request);
  };

  listReceivers = ({ userId, page, max_results }) => {
    const request = {
      method: 'GET',
      url: '/receivers',
      params: {
        user_id: userId,
        page,
        max_results: max_results || 10,
      },
    };
    return this.axios(request);
  };

  addSender = (params) => {
    const request = {
      method: 'POST',
      url: '/sender/add',
      data: {
        user_id: params.userId,
        last_name: params.last_name,
        first_name: params.first_name,
        full_name: params.full_name,
        address_type: params.address_type,
        office_number: params.office_number,
        address_1: params.address_1,
        address_2: params.address_2,
        company: params.company,
        department_1: params.department_1,
        department_2: params.department_2,
        job_title: params.job_title,
        related_members: params.related_members,
      },
    };
    console.log('--- request ---', request);

    return this.axios(request);
  };

  addReceiver = (params) => {
    const request = {
      method: 'POST',
      url: '/receiver/add',
      data: {
        user_id: params.userId,
        last_name: params.last_name,
        first_name: params.first_name,
        full_name: params.full_name,
        title: params.title,
        address_type: params.address_type,
        office_number: params.office_number,
        address_1: params.address_1,
        address_2: params.address_2,
        company: params.company,
        department_1: params.department_1,
        department_2: params.department_2,
        job_title: params.job_title,
        related_members: params.related_members,
      },
    };
    return this.axios(request);
  };

  deleteReceiver = (receiverId) => {
    const request = {
      method: 'DELETE',
      url: '/receiver/delete',
      data: {
        id: receiverId,
      },
    };
    return this.axios(request);
  };

  deleteSender = (senderId) => {
    const request = {
      method: 'DELETE',
      url: '/sender/delete',
      data: {
        id: senderId,
      },
    };
    return this.axios(request);
  };

  updateSender = (params) => {
    const request = {
      method: 'PUT',
      url: '/sender/update',
      data: {
        ...params.senderInput,
      },
    };
    return this.axios(request);
  };

  updateReceiver = (params) => {
    const request = {
      method: 'PUT',
      url: '/receiver/update',
      data: {
        ...params.receiverInput,
      },
    };
    console.log('--- updateReceiver request', request);
    return this.axios(request);
  };

  searchAddressByPostCode = (postCode) => {
    const request = {
      method: 'GET',
      url: `https://madefor.github.io/postal-code-api/api/v1/${postCode.first3Number}/${postCode.last4Number}.json`,
    };
    return axios(request);
  };
}

export default new AtenaService();
